import {Footer as GrommetFooter} from 'grommet'

import LanguageSwitcher from '../../../components/translation/LanguageSwitcher'

export default function Footer() {
  return (
    <GrommetFooter
      gridArea="footer"
      align="bottom"
      justify="center"
      background="dark-2"
      pad={{vertical: 'small', horizontal: 'medium'}}
      round={{corner: 'bottom'}}
    >
      <LanguageSwitcher />
    </GrommetFooter>
  )
}
